/*
 * PostHog events for the Eleonora storefront.
 * snippets/posthog.liquid loads PostHog, describes the page in window.__phCtx and notes bag requests in window.__phQ;
 * this file turns them into events, on top of what PostHog collects by itself (page views, clicks, replays, heatmaps).
 *
 *   product_viewed, variant_selected, product_tab_opened, collection_viewed, store_search, page_not_found
 *   add_to_cart, remove_from_cart, cart_cleared, cart_updated, cart_viewed, checkout_clicked, express_checkout_clicked
 *   product_clicked, collection_clicked, nav_link_clicked, outbound_link_clicked, contact_link_clicked
 *   hero_table_selected, row_arrow_clicked, menu_opened, search_opened, section_viewed, scroll_depth
 *   newsletter_signup, newsletter_signup_confirmed, contact_form_submitted, design_idea_submitted, contact_form_confirmed
 *
 * The checkout and the order (checkout_started ... order_completed) come from the custom pixel, tools/posthog-checkout-pixel.js.
 * It only listens: nothing here changes how the theme behaves, and every page works the same without it.
 */
(function () {
  'use strict';

  var ctx = window.__phCtx;
  if (!ctx) return;

  // window.posthog is looked up on every call: the loader's stand-in is replaced by the real one once it has loaded
  function capture(name, props) {
    try { var ph = window.posthog; if (ph && ph.capture) ph.capture(name, props || {}); } catch (e) { /* never in the way of the page */ }
  }
  function assign(target) {
    for (var i = 1; i < arguments.length; i++) { var from = arguments[i] || {}; for (var key in from) if (from[key] !== undefined) target[key] = from[key]; }
    return target;
  }
  function cents(value) { return typeof value === 'number' ? Math.round(value) / 100 : undefined; }
  function text(el, max) { return el ? String(el.textContent || '').replace(/\s+/g, ' ').trim().slice(0, max || 80) : ''; }
  function param(name) { try { return new URLSearchParams(location.search).get(name); } catch (e) { return null; } }
  // a listener that fails must stay silent: it is only watching
  function quiet(fn) { return function () { try { return fn.apply(this, arguments); } catch (e) { /* skipped */ } }; }

  /* ---------- bag ---------- */

  var lastCart = null, lastAdd = 0;

  function line(item, quantity) {
    var price = cents(item.final_price != null ? item.final_price : item.price);
    var count = quantity == null ? item.quantity : quantity;
    return {
      product_id: item.product_id,
      variant_id: item.variant_id || item.id,
      product_name: item.product_title || item.title,
      variant_name: item.variant_title || undefined,
      product_handle: item.handle,
      sku: item.sku || undefined,
      price: price,
      quantity: count,
      value: price == null ? undefined : Math.round(price * count * 100) / 100,
      currency: ctx.currency
    };
  }
  function cartProps(cart) {
    if (!cart || !cart.items) return { cart_value: ctx.cart.value, cart_item_count: ctx.cart.itemCount, currency: ctx.currency };
    return {
      cart_value: cents(cart.total_price),
      cart_item_count: cart.item_count,
      cart_lines: cart.items.length,
      cart_items: cart.items.map(function (item) { return { product_name: item.product_title, variant_name: item.variant_title, variant_id: item.variant_id, quantity: item.quantity, price: cents(item.final_price) }; }),
      currency: cart.currency || ctx.currency
    };
  }

  function added(sent, got) {
    var asked = {};
    try {
      var body = sent.charAt(0) === '{' ? JSON.parse(sent) : { id: new URLSearchParams(sent).get('id'), quantity: new URLSearchParams(sent).get('quantity') };
      (body.items || [body]).forEach(function (wanted) { asked[String(wanted.id)] = +wanted.quantity || 1; });
    } catch (e) { /* quantity falls back to one */ }
    (got && got.items ? got.items : [got]).forEach(function (item) {
      if (!item || !(item.variant_id || item.id)) return;
      capture('add_to_cart', assign(line(item, asked[String(item.variant_id || item.id)] || 1), { source: ctx.pageType === 'product' ? 'product_page' : ctx.pageType }));
    });
    lastAdd = Date.now();
  }

  // a change made in the bag: compare the cart before and after to say what was taken out or added
  function changed(cart) {
    if (!cart || !cart.items) return;
    if (!lastCart) { capture('cart_updated', cartProps(cart)); return; }
    var before = {}, after = {};
    lastCart.items.forEach(function (item) { before[item.key] = item; });
    cart.items.forEach(function (item) { after[item.key] = item; });
    Object.keys(before).forEach(function (key) {
      var was = before[key].quantity, now = after[key] ? after[key].quantity : 0;
      if (now < was) capture('remove_from_cart', assign(line(before[key], was - now), { removed_line: now === 0, source: 'bag' }, cartProps(cart)));
      else if (now > was) capture('add_to_cart', assign(line(after[key], now - was), { source: 'bag' }, cartProps(cart)));
    });
  }

  var firstCart = null; // called once, with the first cart state seen on this page
  function handle(entry) {
    if (!entry) return;
    try {
      if (entry.kind === 'add') { added(entry.sent || '', entry.got); return; }
      if (entry.kind === 'change') changed(entry.got);
      else if (entry.kind === 'clear') capture('cart_cleared', cartProps(lastCart));
      if (entry.got && entry.got.items && entry.got.token !== undefined) {
        lastCart = entry.got;
        if (firstCart) { var once = firstCart; firstCart = null; once(); }
      }
    } catch (e) { /* a malformed answer is skipped */ }
  }

  /* ---------- what this page is ---------- */

  function currentVariant() {
    var product = ctx.product;
    if (!product) return null;
    var input = document.querySelector('[data-product-form] [name="id"]');
    var id = input ? String(input.value) : param('variant');
    return product.variants.filter(function (v) { return String(v.id) === id; })[0] || product.variants[0] || null;
  }
  function productProps() {
    var product = ctx.product, variant = currentVariant() || {};
    return {
      product_id: product.id, product_name: product.name, product_handle: product.handle, product_type: product.type || undefined, vendor: product.vendor,
      collection: product.collection, collection_name: product.collectionName, tags: product.tags, available: product.available, photos: product.photos, image: product.image,
      variant_id: variant.id, variant_name: variant.name, sku: variant.sku || undefined, price: variant.price, currency: ctx.currency
    };
  }

  function pageEvents() {
    if (ctx.product) {
      capture('product_viewed', productProps());
    } else if (ctx.collection) {
      capture('collection_viewed', {
        collection_id: ctx.collection.id, collection_name: ctx.collection.name, collection_handle: ctx.collection.handle,
        products_count: ctx.collection.productsCount, products_shown: document.querySelectorAll('.shelf .tile').length, page: ctx.collection.page, sort_by: ctx.collection.sortBy
      });
    } else if (ctx.search && ctx.search.performed) {
      capture('store_search', { query: ctx.search.terms, results_count: ctx.search.resultsCount });
    } else if (ctx.pageType === '404') {
      capture('page_not_found', { path: location.pathname + location.search, came_from: document.referrer || undefined });
    } else if (ctx.pageType === 'cart') {
      var seen = false;
      var view = function () { if (seen) return; seen = true; capture('cart_viewed', assign({ surface: 'page' }, cartProps(lastCart))); };
      if (lastCart) view(); else { firstCart = view; setTimeout(view, 2500); }
    }
    // Shopify sends the visitor back to the page with these after a form went through
    if (param('customer_posted') === 'true') capture('newsletter_signup_confirmed', {});
    if (param('contact_posted') === 'true') capture(ctx.template === 'page.submit' ? 'design_idea_confirmed' : 'contact_form_confirmed', {});
  }

  /* ---------- clicks ---------- */

  var PLACES = [
    ['.swatches', 'print_swatches'], ['.buy__back', 'back_link'], ['.others', 'more_from_collection'], ['.stage', 'hero'], ['.row', 'home_row'],
    ['.band', 'collection_band'], ['.tables', 'tables'], ['.feature', 'feature'], ['.invite', 'invite'], ['[data-drawer]', 'bag'], ['.cartpage', 'bag'],
    ['.mobile-menu', 'mobile_menu'], ['.header', 'header'], ['.footer', 'footer'], ['.shelf', 'grid']
  ];
  function place(el) {
    for (var i = 0; i < PLACES.length; i++) if (el.closest(PLACES[i][0])) return PLACES[i][1] === 'grid' ? (ctx.pageType === 'search' ? 'search_results' : ctx.pageType === 'list-collections' ? 'collections_page' : 'collection_grid') : PLACES[i][1];
    return ctx.pageType;
  }
  function position(link) {
    var kind = link.classList.contains('tile') ? '.tile' : link.classList.contains('photo') ? '.photo' : link.classList.contains('swatch') ? '.swatch' : null;
    if (!kind || !link.parentElement) return undefined;
    return [].indexOf.call(link.parentElement.querySelectorAll(':scope > ' + kind), link) + 1 || undefined;
  }

  // the wallet button inside Shopify's element, by its tag name (shop-pay-wallet-button, shopify-apple-pay-button, ...)
  function wallet(e) {
    var path = e.composedPath ? e.composedPath() : [];
    for (var i = 0; i < path.length; i++) { var tag = path[i].localName || ''; if (/-button$/.test(tag)) return tag; }
    return undefined;
  }

  function onLink(link) {
    var url;
    try { url = new URL(link.href, location.href); } catch (e) { return; }
    if (/^(mailto|tel|sms):$/.test(url.protocol)) { capture('contact_link_clicked', { kind: url.protocol.replace(':', ''), where: place(link) }); return; }
    if (!/^https?:$/.test(url.protocol)) return;
    var label = link.getAttribute('aria-label') || text(link.querySelector('.tile__name, .name')) || text(link) || link.getAttribute('title') || undefined;
    if (url.origin !== location.origin) { capture('outbound_link_clicked', { href: url.href, label: label, where: place(link) }); return; }
    var where = place(link);
    var product = /\/products\/([^/?#]+)/.exec(url.pathname), collection = /\/collections\/([^/?#]+)/.exec(url.pathname);
    if (product) capture('product_clicked', { product_handle: decodeURIComponent(product[1]), product_name: label, where: where, position: position(link), href: url.pathname });
    else if (collection) capture('collection_clicked', { collection_handle: decodeURIComponent(collection[1]), collection_name: label, where: where, position: position(link), href: url.pathname });
    else if (where === 'header' || where === 'mobile_menu' || where === 'footer') capture('nav_link_clicked', { label: label, href: url.pathname + url.hash, where: where });
  }

  function onClick(e) {
    var target = e.target;
    if (!target || !target.closest) return;

    // Shopify's wallet buttons (Shop Pay, Apple Pay, Google Pay; PayPal draws inside its own frame, so its clicks never reach the page)
    var express = target.closest('shopify-accelerated-checkout, shopify-accelerated-checkout-cart, .shopify-payment-button');
    if (express) {
      capture('express_checkout_clicked', assign({ surface: express.closest('[data-drawer]') ? 'drawer' : ctx.pageType === 'product' ? 'product_page' : ctx.pageType, wallet: wallet(e) },
        ctx.product ? { product_handle: ctx.product.handle, product_name: ctx.product.name } : {}, cartProps(lastCart)));
      return;
    }

    var checkout = target.closest('button[name="checkout"], input[name="checkout"], a[href*="/checkout"]');
    if (checkout) { capture('checkout_clicked', assign({ surface: checkout.closest('[data-drawer]') ? 'drawer' : 'cart_page' }, cartProps(lastCart))); return; }

    var tab = target.closest('[data-tab]');
    if (tab) { capture('product_tab_opened', assign({ tab: text(tab) }, ctx.product ? { product_handle: ctx.product.handle, product_name: ctx.product.name } : {})); return; }

    var arrow = target.closest('[data-go]');
    if (arrow) { capture('row_arrow_clicked', { direction: +arrow.getAttribute('data-go') > 0 ? 'forward' : 'back', where: place(arrow) }); return; }

    if (target.closest('[data-menu-toggle]')) { if (!document.body.classList.contains('menu-open')) capture('menu_opened', {}); return; }
    if (target.closest('[data-search-toggle]')) { if (!document.body.classList.contains('search-open')) capture('search_opened', { where: 'header' }); return; }

    // the cart page works without script: its remove links are ordinary links
    var remove = target.closest('.cartpage .line__remove');
    if (remove && lastCart) {
      var row = remove.closest('.line'), rows = row && row.parentElement ? [].slice.call(row.parentElement.querySelectorAll('.line')) : [];
      var item = lastCart.items[rows.indexOf(row)];
      if (item) capture('remove_from_cart', assign(line(item), { removed_line: true, source: 'cart_page' }));
      return;
    }
    if (target.closest('.cartpage button[name="update"]')) { capture('cart_updated', assign({ source: 'cart_page' }, cartProps(lastCart))); return; }

    var link = target.closest('a[href]');
    if (link && !link.hasAttribute('data-bag-open')) onLink(link);
  }

  /* ---------- forms ---------- */

  function onSubmit(e) {
    var form = e.target;
    if (!form || form.nodeName !== 'FORM') return;
    var type = form.querySelector('input[name="form_type"]');
    type = type ? type.value : '';
    var field = function (name) { var el = form.querySelector('[name="contact[' + name + ']"]'); return el && el.value ? String(el.value).trim() : ''; };
    var person = {};
    if (field('email')) person.email = field('email').toLowerCase();
    if (field('name')) person.name = field('name');
    if (type === 'customer') {
      capture('newsletter_signup', { where: place(form), tags: field('tags') || undefined, $set: person });
    } else if (type === 'contact') {
      var idea = field('subject') === 'Design idea' || ctx.template === 'page.submit';
      capture(idea ? 'design_idea_submitted' : 'contact_form_submitted', { message_length: field('body').length, has_link: idea ? !!field('link') : undefined, $set: person });
    }
  }

  function onChange(e) {
    var target = e.target;
    if (!target || !target.matches || !ctx.product || !target.matches('[data-option] input')) return;
    // the theme has already written the chosen variant into the form by the time this runs
    setTimeout(function () {
      var variant = currentVariant();
      if (variant) capture('variant_selected', { product_id: ctx.product.id, product_name: ctx.product.name, product_handle: ctx.product.handle, variant_id: variant.id, variant_name: variant.name, option: target.value, price: variant.price, available: variant.available, currency: ctx.currency });
    }, 0);
  }

  /* ---------- watching the page ---------- */

  function watchBag() {
    var open = document.body.classList.contains('bag-open');
    new MutationObserver(function () {
      var now = document.body.classList.contains('bag-open');
      if (now && !open) {
        var afterAdd = Date.now() - lastAdd < 5000;
        // a moment's wait, so the cart that an add has just changed is the one reported
        setTimeout(function () { capture('cart_viewed', assign({ surface: 'drawer', after_add: afterAdd }, cartProps(lastCart))); }, 250);
      }
      open = now;
    }).observe(document.body, { attributes: true, attributeFilter: ['class'] });
  }

  function watchHero() {
    var list = document.querySelector('[data-stage-list]');
    if (!list) return;
    var current = list.querySelector('[aria-current="true"]');
    new MutationObserver(function () {
      var now = list.querySelector('[aria-current="true"]');
      if (!now || now === current) return;
      current = now;
      var buttons = [].slice.call(list.querySelectorAll('[data-pick]'));
      capture('hero_table_selected', { table: now.getAttribute('data-name'), kind: now.getAttribute('data-kind') || undefined, position: buttons.indexOf(now) + 1, href: now.getAttribute('data-url') || undefined });
    }).observe(list, { attributes: true, attributeFilter: ['aria-current'], subtree: true });
  }

  function watchSections() {
    if (!('IntersectionObserver' in window)) return;
    var sections = [].slice.call(document.querySelectorAll('.shopify-section'));
    // a section counts as seen once it reaches the middle of the screen
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        observer.unobserve(entry.target);
        var inner = entry.target.firstElementChild;
        capture('section_viewed', {
          section_id: (entry.target.id || '').replace('shopify-section-', '').replace(/^(template|sections)--\d+__/, ''),
          section: inner ? (inner.className || inner.nodeName).toString().split(' ')[0].toLowerCase() : undefined,
          heading: text(entry.target.querySelector('h1, h2, .footer__title'), 60) || undefined,
          position: sections.indexOf(entry.target) + 1,
          sections_on_page: sections.length
        });
      });
    }, { rootMargin: '-45% 0px -45% 0px', threshold: 0 });
    sections.forEach(function (section) { if (section.offsetHeight > 0) observer.observe(section); });
  }

  function watchScroll() {
    var marks = [25, 50, 75, 100], queued = false;
    function measure() {
      queued = false;
      var full = document.documentElement.scrollHeight, seen = window.scrollY + window.innerHeight;
      if (full < window.innerHeight * 1.2) return; // a page that fits the screen has no depth to speak of
      while (marks.length && seen / full * 100 >= marks[0] - 0.5) capture('scroll_depth', { percent: marks.shift(), page_height: full });
      if (!marks.length) window.removeEventListener('scroll', onScroll);
    }
    function onScroll() { if (!queued) { queued = true; requestAnimationFrame(measure); } }
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ---------- consent ---------- */

  // Shopify's own answer to "may this visitor be measured?". It says yes wherever the shop asks for no consent.
  function consent() {
    var apply = function () {
      try {
        var privacy = window.Shopify && window.Shopify.customerPrivacy, ph = window.posthog;
        if (!privacy || !privacy.analyticsProcessingAllowed || !ph || !ph.opt_out_capturing) return;
        if (!privacy.analyticsProcessingAllowed()) ph.opt_out_capturing();
        else if (ph.has_opted_out_capturing && ph.has_opted_out_capturing()) ph.opt_in_capturing();
      } catch (e) { /* left as it was */ }
    };
    document.addEventListener('visitorConsentCollected', apply);
    document.addEventListener('posthog:loaded', apply);
    try {
      if (window.Shopify && window.Shopify.loadFeatures) window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) { if (!error) apply(); });
    } catch (e) { /* no consent API: nothing to apply */ }
  }

  /* ---------- start ---------- */

  function run() {
    var queue = window.__phQ || [];
    queue.splice(0).forEach(handle);
    queue.push = function (entry) { handle(entry); return 0; };
    window.__phQ = queue;

    document.addEventListener('click', quiet(onClick), true);
    document.addEventListener('submit', quiet(onSubmit), true);
    document.addEventListener('change', quiet(onChange));
    [watchBag, watchHero, consent].forEach(function (watch) { quiet(watch)(); });
    // a page opened in a background tab has not been looked at yet; PostHog holds its page view back in the same way
    var look = function () {
      if (document.visibilityState !== 'visible') return;
      document.removeEventListener('visibilitychange', look);
      [pageEvents, watchSections, watchScroll].forEach(function (watch) { quiet(watch)(); });
    };
    document.addEventListener('visibilitychange', look);
    look();
    // a page brought back by the back button is a new view of it
    window.addEventListener('pageshow', function (e) { if (e.persisted) capture('$pageview', { restored: true }); });
  }

  // a page loaded ahead of the tap is not a visit until it is shown (the loader waits in the same way)
  if (document.prerendering) document.addEventListener('prerenderingchange', run, { once: true }); else run();
})();
